export const getWebSocketUrl = (): string => {
    const envWsUrl = process.env.REACT_APP_WS_URL;
    const envApiUrl = process.env.REACT_APP_API_URL;

    // 1. Explicit WS URL environment variable (if provided at build/runtime)
    if (envWsUrl && envWsUrl.trim() !== '') {
        return envWsUrl;
    }

    // 2. Derive WS URL from REACT_APP_API_URL if present
    if (envApiUrl && envApiUrl.trim() !== '') {
        try {
            if (envApiUrl.startsWith('https://')) {
                return envApiUrl.replace('https://', 'wss://') + '/socket';
            }
            if (envApiUrl.startsWith('http://')) {
                return envApiUrl.replace('http://', 'ws://') + '/socket';
            }
            const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
            const cleanApiUrl = envApiUrl.endsWith('/') ? envApiUrl.slice(0, -1) : envApiUrl;
            return `${protocol}//${window.location.host}${cleanApiUrl}/socket`;
        } catch (e) {
            // fallback to window.location
        }
    }

    // 3. Fallback to current window host
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${protocol}//${window.location.host}/socket`;
};
